import { render } from "./UiProgressBar.vue?vue&type=template&id=71cbdb4f"
import script from "./UiProgressBar.vue?vue&type=script&lang=js"
export * from "./UiProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__